import React, { useEffect, useRef } from 'react';
import "@arcgis/core/assets/esri/themes/dark/main.css"; // სტილების იმპორტი
import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import { Tooltip } from "@mui/material";
import "./ContactMapStyle.css";

export const ContactMap = ({ children }) => {
    const mapRef = useRef(null);
    const viewRef = useRef(null);

    useEffect(() => {
        if (!mapRef.current) return;

        // რუკის ინიციალიზაცია
        const map = new Map({
            basemap: "dark-gray-vector"
        });

        const view = new MapView({
            container: mapRef.current,
            map: map,
            center: [44.71369923210905, 41.72002327938312],
            zoom: 15,
            ui: {
                components: [] // აშორებს zoom ღილაკებს და სხვა UI-ს
            },
            navigation: {
                mouseWheelZoomEnabled: false // თიიშავს სკროლით ზუმს
            }
        });

        viewRef.current = view;

        // ინტერაქციების გათიშვა (Static Map ეფექტისთვის)
        const stopProp = (event) => event.stopPropagation();
        
        view.on("drag", stopProp);
        view.on("key-down", stopProp);
        view.on("double-click", stopProp);
        view.on("mouse-wheel", stopProp);

        // წერტილის დამატება
        const graphicsLayer = new GraphicsLayer();
        const point = {
            type: "point",
            longitude: 44.71369923210905,
            latitude: 41.72002327938312
        };

        const contenttxt = `
            <div style="font-family:FiraGoBold, serif; font-size:15px; line-height: 21px;">
                <div>თბილისი 0186</div>
                <div style="margin-top:5px;">ანა პოლიტკოვსკაიას ქ. N8(ყოფ. ჯიქია), IV სართული</div>
            </div>
        `;

        const symbol = {
            type: "picture-marker",
            url: "img/contactMapIcon.png",
            width: "42px",
            height: "42px"
        };

        const pointGraphic = new Graphic({
            geometry: point,
            symbol: symbol,
            popupTemplate: {
                title: "",
                content: contenttxt,
                actions: []
            }
        });

        graphicsLayer.add(pointGraphic);
        map.add(graphicsLayer);

        // გასუფთავება (Cleanup) კომპონენტის წაშლისას
        return () => {
            if (viewRef.current) {
                viewRef.current.destroy();
            }
        };
    }, []);

    const mapContainerStyle = {
        borderRadius: '60px',
        overflow: 'hidden',
        marginTop: 10,
        height: '400px', // დარწმუნდი რომ სიმაღლე გაწერილია
        width: '100%',
        cursor: 'pointer'
    };

    const lang = localStorage.getItem("lang");

    const handleMapClick = () => {
        // Google Maps-ზე გადასვლის ლოგიკა
        window.open("https://www.google.com/maps?q=41.72002327938312,44.71369923210905", "_blank");
    };

    return (
        <div>
            <Tooltip
                title={lang === "eng" ? "Click on the map to go to Google Maps" : "Google Maps-ზე გადასვლისთვის დააჭირეთ რუკას"}
                placement="top"
            >
                <div 
                    style={mapContainerStyle} 
                    className="contact-map-container" 
                    ref={mapRef}
                    onClick={handleMapClick}
                >
                    {children}
                </div>
            </Tooltip>
        </div>
    );
};

export default ContactMap;